import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

function Piechart({ follower_profile_ages, follower_profile_genders }) {
    const { t } = useTranslation();
    const [pieChartData, setPieChartData] = useState(null);
    const [pieChartOptions, setPieChartOptions] = useState(null);
    
    useEffect(() => {
        if (!follower_profile_ages && !follower_profile_genders) return;

        var data = follower_profile_ages;
        if (follower_profile_genders) {
            data = follower_profile_genders;
        }

        const labels = data.map(item => item.key);
        const pieData = data.map(item => (parseFloat(item.value) * 100).toFixed(2));
        const backgroundColors = labels.map((_, i) => `hsl(${i * 60}, 70%, 60%, 0.8)`);

        setPieChartData({
            labels,
            datasets: [
                {
                    label: follower_profile_ages ? "Followerage" : "Followergender",
                    data: pieData,
                    backgroundColor: backgroundColors,
                    borderWidth: 1,
                },
            ],
        });

        setPieChartOptions({
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                    tooltip: { enabled: true },
                    datalabels: { display: false },
                },
                title: {
                    display: true,
                    text: follower_profile_ages ? t("Followerage") : t("Followergender"),
                },
                tooltip: {
                    callbacks: {
                    label: function (ctx) {
                        const label = ctx.label || "";
                        const value = ctx.parsed || 0;
                        return `${label}: ${value.toFixed(2)}%`;
                    },
                    },
                },
                datalabels: {
                    formatter: function (value) {
                        return value + "%";
                    },
                },
            },
        });
    }, [follower_profile_ages, follower_profile_genders, t]);

    return (
        <Fragment>
            {pieChartData && pieChartOptions && (
                <Pie type="bar" data={pieChartData} options={pieChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Piechart);